<template>
  <div id="service-selection-form">
    <el-form
      ref="dataForm"
      :model="order"
      label-position="top"
      require-asterisk-position="right"
    >
      <div class="container">
        <p class="title">{{ $t('components.order-form.parameterTitle') }}</p>
        <el-form-item>
          <el-checkbox-group v-model="order.fenceSunService">
            <el-checkbox
              v-for="(item, index) in fenceSunServices"
              :key="index"
              :label="item.service"
              size="large"
            >
              <p class="checkbox">{{ item.service }} - {{ item.price }}€</p>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
  
<script lang="ts">
import { OrderRequestData } from '@/services/api/orderService';
import { fenceSunServices } from '@/types/constants/fence-sun';
import { Component, Vue, Prop } from 'vue-facing-decorator';

@Component({
    name: 'ServiceSelectionForm'
  })
  export default class ServiceSelectionForm extends Vue {
    formatCurrency(value: number): string {
      return '€' + parseFloat(String(value)).toFixed(2);
    }

    @Prop() order!: OrderRequestData;
  
    fenceSunServices = fenceSunServices;
  }
  </script>
  
  <style lang="scss" scoped>
  .checkbox {
      font-size: 18px;
  }
  
  #service-selection-form {
      .title {
          font-size: 18px;
          margin-bottom: 1rem;
      }
  
      .el-checkbox-group {
          display: flex;
          flex-wrap: wrap;
  
          .el-checkbox {
              width: 45%;          // Each checkbox takes half the row
              display: flex;
              align-items: center;
          }
      }
  }
  </style>
